var cov_2o6j7nwfvl = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Pagination/Simple.tsx",
      hash = "6976ea95df77ebe161f61b0eb25ee9b1d59e1bad",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Pagination/Simple.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 19,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 11
          },
          end: {
            line: 20,
            column: 3
          }
        },
        line: 12
      }
    },
    branchMap: {},
    s: {
      "0": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Pagination/Simple.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { getDirectionClass } from '../utils/classname';
import Jumper from './Jumper';
import Prev from './Prev';
import Next from './Next';
import { paginationClass } from './styles';

var Simple =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Simple, _PureComponent);

  var _super = _createSuper2(Simple);

  function Simple() {
    _classCallCheck(this, Simple);

    return _super.apply(this, arguments);
  }

  _createClass(Simple, [{
    key: "render",
    value: function render() {
      cov_2o6j7nwfvl.f[0]++;
      cov_2o6j7nwfvl.s[0]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: paginationClass('links', getDirectionClass('section')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 14,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Prev, Object.assign({}, this.props, {
          isSimple: true,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 15,
            columnNumber: 9
          }
        })),
        /*#__PURE__*/
        React.createElement(Jumper, Object.assign({}, this.props, {
          isSimple: true,
          size: "small",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 16,
            columnNumber: 9
          }
        })),
        /*#__PURE__*/
        React.createElement(Next, Object.assign({}, this.props, {
          isSimple: true,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 17,
            columnNumber: 9
          }
        })))
      );
    }
  }]);

  return Simple;
}(PureComponent);

export default Simple;